import { render, staticRenderFns } from "./protectionInfo.vue?vue&type=template&id=44c0d796&scoped=true"
import script from "./protectionInfo.vue?vue&type=script&lang=js"
export * from "./protectionInfo.vue?vue&type=script&lang=js"
import style0 from "./protectionInfo.vue?vue&type=style&index=0&id=44c0d796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c0d796",
  null
  
)

export default component.exports